module.exports = __webpack_public_path__ + "img/partner9.a52d9eb0.png";